export class ReportConstants {

    // DeclarationReports
    static TwelveMonthUtilizationReport = 'RPT001';
    static CheckListAgeingReport = 'RPT002';
    static ClientExecutiveSummaryReport = 'RPT003';
    static CompleteRecordsReport = 'RPT005';
    static DashboardReport = 'RPT006';
    static DataStatusReport = 'RPT040'
    static DeclarationDetailReport = 'RPT007';
    static DeclarationSummaryReport = 'RPT008';
    static DetailedTurnOverReport = 'RPT009';
    static DivisionExposureReport = 'RPT010';
    static DivisionTotalsReport = 'RPT042';
    static FranchiseLossLimitReport = 'RPT011';
    static ImportDetailsReport = 'RPT012';
    static InsuredDebtorReport = 'RPT013';
    static InsuredDebtorsGrantedVsExposures = 'RPT014';
    static LimitValueChangesReport = 'RPT015';
    static LinkedDebtorReport = 'RPT016';
    static LinkedDebtorsCreditReport = 'RPT017';
    static LimitsReport = 'RPT018';
    static NegativeBalanceReport = 'RPT019';
    static OverdueAccountsDetailedReport = 'RPT020';
    static OverdueAccountsReport = 'RPT021';
    static OvertradesReport = 'RPT022';
    static PolicyScheduleReport = 'RPT024';
    static RenewalReportPack = 'RPT026';
    static ReportPack = 'RPT027';
    static SharedDebtorbyDivision = 'RPT028';
    static SpecialConditionsReport = 'RPT029';
    static SpecialConditionsReportManual = 'RPT030';
    static TurnoverChecklistReport = 'RPT031';
    static TurnoverReport = 'RPT032';
    static UninsurableDebtorReport = 'RPT033';
    static UninsuredDebtorReport = 'RPT034';
    static UnutilizedInsurerLimitsReport = 'RPT035';
    static UserReport = 'RPT036';
    static ActivityLogReport = 'RPT037';
    static AnnexureExportReport = 'RPT038';
    static AgeingExportReport = 'RPT039';
    static SharedDebtorByPolicyReport = 'RPT043';

    // RenewalReports
    static ClaimsReport = 'RPT004';
    static PerformanceBonusReport = 'RPT023';
    static PremiumsReport = 'RPT025';

    // AdhocGeneral
    static Utilisation12MonthReport = 'RPT041';
    //

    static friendlyNames: Record<string, string> = {
        [ReportConstants.TwelveMonthUtilizationReport]: 'Twelve Month Utilization Report',
        [ReportConstants.CheckListAgeingReport]: 'Checklist Report',
        [ReportConstants.ClientExecutiveSummaryReport]: 'Client Executive Summary Report',
        [ReportConstants.CompleteRecordsReport]: 'Complete Records Report',
        [ReportConstants.DashboardReport]: 'Dashboard Report',
        [ReportConstants.DataStatusReport]: 'Data Status Report',
        [ReportConstants.DeclarationDetailReport]: 'Declaration Detail Report',
        [ReportConstants.DeclarationSummaryReport]: 'Declaration Summary Report',
        [ReportConstants.DetailedTurnOverReport]: 'Detailed Turnover Report',
        [ReportConstants.DivisionExposureReport]: 'Division Exposure Report',
        [ReportConstants.DivisionTotalsReport]: 'Division Totals Report',
        [ReportConstants.FranchiseLossLimitReport]: 'Non-Qualifying Loss Limit Report',
        [ReportConstants.ImportDetailsReport]: 'Import Detail Report',
        [ReportConstants.InsuredDebtorReport]: 'Insured Debtor Report',
        [ReportConstants.InsuredDebtorsGrantedVsExposures]: 'Insured Debtors Granted vs Exposures',
        [ReportConstants.LimitValueChangesReport]: 'Limit Value Changes Report',
        [ReportConstants.LinkedDebtorReport]: 'Linked Debtor Report',
        [ReportConstants.LinkedDebtorsCreditReport]: 'Linked Debtors Credit Report',
        [ReportConstants.LimitsReport]: 'Limits Report',
        [ReportConstants.NegativeBalanceReport]: 'Negative Balance Report',
        [ReportConstants.OverdueAccountsDetailedReport]: 'Overdue Accounts Detailed Report',
        [ReportConstants.OverdueAccountsReport]: 'Overdue Accounts Report',
        [ReportConstants.OvertradesReport]: 'Overtrades Report',
        [ReportConstants.PolicyScheduleReport]: 'Policy Schedule Report',
        [ReportConstants.RenewalReportPack]: 'Renewal Report Pack',
        [ReportConstants.ReportPack]: 'Report Pack',
        [ReportConstants.SharedDebtorbyDivision]: 'Shared Debtor by Division',
        [ReportConstants.SpecialConditionsReport]: 'Special Conditions Report',
        [ReportConstants.SpecialConditionsReportManual]: 'Special Conditions Report Manual',
        [ReportConstants.TurnoverChecklistReport]: 'Turnover Checklist',
        [ReportConstants.TurnoverReport]: 'Turnover Report',
        [ReportConstants.UninsurableDebtorReport]: 'Uninsurable Debtor Report',
        [ReportConstants.UninsuredDebtorReport]: 'Uninsured Debtor Report',
        [ReportConstants.UnutilizedInsurerLimitsReport]: 'Unutilized Insurer Limits Report',
        [ReportConstants.UserReport]: 'User Report',
        [ReportConstants.ActivityLogReport]: 'Activity Log Report',
        [ReportConstants.AnnexureExportReport]: 'Annexure Export Report',
        [ReportConstants.AgeingExportReport]: 'Ageing Export Report',
        [ReportConstants.SharedDebtorByPolicyReport]: 'Shared Debtor by Policy Report',
        [ReportConstants.ClaimsReport]: 'Claims Report',
        [ReportConstants.PerformanceBonusReport]: 'Performance Bonus Report',
        [ReportConstants.PremiumsReport]: 'Premiums Report',
        [ReportConstants.Utilisation12MonthReport]: 'Utilisation 12 Month Report',
    };
}